import _ from 'lodash';
import {
  GRADEBOOK_SETTINGS,
  precisionFrom,
  round,
} from '@macmillan-learning/gradebook-shared';

export const getAssignedPoints = (asgn) => {
  const assignmentException = asgn.studentAssignmentException
    ? asgn.studentAssignmentException
    : asgn.Exceptions?.find(
        (ex) =>
          ex.assignment_id === asgn.id && ex.exception_type === 'assignment',
      );
  if (assignmentException) {
    const pts = _.get(
      assignmentException,
      'exception_value.assigned_points',
      0,
    );
    return parseFloat(pts);
  }
  return _.isNumber(asgn.assigned_points) ? asgn.assigned_points : 0;
};

export const getIsAssigned = (assignment, student, exceptions = []) => {
  let isAssigned = false;
  let assignmentExceptions;

  if (Array.isArray(exceptions)) {
    assignmentExceptions = exceptions.find(
      (ex) =>
        ex.assignment_id === assignment.id &&
        ex.exception_type === 'assignment' &&
        ex.user_ids.includes(student.studentId),
    );
  }

  if ((assignment && assignment.assignment_due_at) || assignmentExceptions) {
    // If is assigned to everyone or assigned to this student, isAssigned is true
    isAssigned = true;
  }
  return isAssigned;
};

export const formatDisplayPercentage = (
  percentage,
  roundPercentType = GRADEBOOK_SETTINGS.roundPercentWhole,
) => {
  const roundedPercentage = round(percentage, precisionFrom(roundPercentType));
  return `${roundedPercentage}%`;
};

export const getNCategoryAssignmentsCountDropdown = (assignmentCount) => {
  const items = [];
  for (let i = 0; i <= assignmentCount; i++) {
    const newItem = { label: `${i}`, value: i };
    items.push(newItem);
  }
  return items;
};

/* Turns an array shaped like this:
[
  {
    assignmentId: 'a6001436-c13b-4335-9b6a-910427525751',
    userId: '0053B000002AgChQAK',
    timeOnAssignmentInMins: 58
  }
]
Into a map shaped like this:
{
  '0053B000002AgChQAK': {
    'a6001436-c13b-4335-9b6a-910427525751': 58,
  }
}
*/

export const sortByKey = (items, key) => {
  items.sort((a, b) => {
    const valA = _.get(a, `[${key}]`, '').toUpperCase();
    const valB = _.get(b, `[${key}]`, '').toUpperCase();
    if (valA < valB) return -1;
    if (valA > valB) return 1;
    return 0;
  });
  return items;
};

export const createIndividualStudentGradebookUrl = ({
  studentId,
  showPercent,
}) => {
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.set('studentId', studentId);
  searchParams.set('showPercent', showPercent);
  return `${window.location.pathname}?${searchParams.toString()}`;
};

export const normalizeString = (str) => {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};
